/* eslint no-underscore-dangle: 0 */
import { SESSION_CACHE, SESSION_SUCCESS, SHORTLIST_CREATE_SUCCESS, UNAUTH } from 'actionTypes';

const initialState = {
  items: [],
};

const rename = str => (str === 'My 1st List' ? `My Maybe's` : str);

const shortlist = (state = {}, action) => {
  switch (action.type) {
    case SHORTLIST_CREATE_SUCCESS:
    case SESSION_SUCCESS:
      return {
        ...state,
        key: `sl-${action.payload.id}`,
        id: `${action.payload.id}`,
        label: rename(action.payload.name),
      };
    default:
      return state;
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SESSION_CACHE:
    case SESSION_SUCCESS:
      return {
        ...state,
        items: action.payload.map(item => shortlist(undefined, { ...action, payload: item })),
      };
    case SHORTLIST_CREATE_SUCCESS:
      return {
        ...state,
        items: state.items.concat([shortlist(undefined, action)]),
      };
    case UNAUTH:
      return false;
    default:
      return state;
  }
}
